import { StatusProps } from 'components/Table/style/Table.style';
import { HORSE_RACING_URL } from 'config';

export const url_ippica = HORSE_RACING_URL;

export const tototipster = 1001;

export const listBetsState = [
  { optionId: 0, label: 'tableBets.listBetsState.all' },
  { optionId: 1, label: 'tableBets.listBetsState.notWinning' },
  { optionId: 2, label: 'tableBets.listBetsState.issued' },
  { optionId: 3, label: 'tableBets.listBetsState.winning' },
];

export const listBetsToto = [
  { optionId: 1000, label: 'tableBets.listBetsToto.simpleBet' },
  { optionId: 1001, label: 'tableBets.listBetsToto.board' },
];

export const listPeriodBets = [
  { label: 'tableBets.listPeriodBets.last7Days', optionId: 7 },
  { label: 'tableBets.listPeriodBets.last15Days', optionId: 15 },
  { label: 'tableBets.listPeriodBets.all', optionId: -1 },
];

export const listPeriodTotocalcio = [
  { label: 'tableBets.listPeriodTotocalcio.last7Days', optionId: 7 },
  { label: 'tableBets.listPeriodTotocalcio.last15Days', optionId: 15 },
  { label: 'tableBets.listPeriodTotocalcio.last3Months', optionId: 90 },
];

export const listPeriodVRBets = [
  { label: 'tableBets.listPeriodVRBets.last7Days', optionId: 7 },
  { label: 'tableBets.listPeriodVRBets.last15Days', optionId: 15 },
  { label: 'tableBets.listPeriodVRBets.all', optionId: 99 },
];

export enum BetsTypeSection {
  sport = 2,
  ippica = 16,
  // totocalcioOld = 910, // Actually is 10 as for totocalcio but we pass a mocked 910 to BE
  totocalcio = 10,
  // totogol = 11,
  virtualRace = 15,
}

export const listBetsType = [
  { optionId: BetsTypeSection.sport, label: 'Sport' },
  { optionId: BetsTypeSection.virtualRace, label: 'Virtual Race' },
];

// The initial value of 'select-bets-state'.
export const defaultSelectlistBetsStateOption = listBetsState[0].optionId;

// The initial value of 'select-bets-type'
export const defaultSelectListBetsTypeStateOption = listBetsType[0].optionId;

// The initial value of 'select-period'
export const defaultSelectListPeriodBetsOption = listPeriodBets.find(
  (period) => period.optionId === -1,
)!.optionId;

// The initial value of 'select-period' for Virtual Race
export const defaultSelectedListPeriodVRBetsOption = listPeriodVRBets.find(
  (period) => period.optionId === 99,
)!.optionId;

// The initial value of 'select-period' for Totocalcio
export const defaultSelectListPeriodTotocalcioOption =
  listPeriodTotocalcio.find((period) => period.optionId === 90)!.optionId;

// The initial value of 'select-bets-tototipster'
export const defaultSelectListBetsTotoOption = listBetsToto[0].optionId;

export const statusBetsVirtual = {
  0: 'RED',
  1: 'GREY',
  3: 'GREEN',
  4: 'GREEN',
  5: 'BLUE',
  10: 'YELLOW',
  11: 'YELLOW',
  12: 'YELLOW',
} as StatusProps;

export const statusBets = {
  0: 'RED',
  1: 'GREY',
  3: 'GREEN',
  4: 'GREEN',
  5: 'BLUE',
  10: 'YELLOW',
  11: 'YELLOW',
  12: 'YELLOW',
} as StatusProps;

export const allStatusBetsIds: {
  [key: string]: any;
} = statusBets;

export const allStatusBetsVirtualIds: {
  [key: string]: any;
} = statusBetsVirtual;

export const statusLegendBets = {
  GREEN: 'lbl.winning',
  RED: 'lbl.not.winning',
  GREY: 'lbl.issued',
  BLUE: 'lbl.refunded',
  YELLOW: 'lbl.waiting',
};
//gameTypeCode_applicationCode_systemTypeCode
export const AllBetsTypes = {
  '2_1_0': 'lbl.betsType.2_1_0',
  '2_1_1': 'lbl.betsType.2_1_1',
  '2_1_2': 'lbl.betsType.2_1_2',
  '3_1_0': 'lbl.betsType.3_1_0',
  '4_1_0': 'lbl.betsType.4_1_0',
  '7_1_0': 'lbl.betsType.7_1_0',
  '10_3': 'lbl.betsType.10_3', // Tototipster
  '10_0': 'lbl.betsType.10_0',
  // '11_0': 'Totogol',
  '15_1_0': 'lbl.betsType.15_1_0',
  '15_3_0': 'lbl.betsType.15_3_0',
  '15_3_1': 'lbl.betsType.15_3_1',
  '15_1_1': 'lbl.betsType.15_1_1',
  '15_3_2': 'lbl.betsType.15_3_2',
  '15_1_2': 'lbl.betsType.15_1_2',
};

export const allBetsTypesIds: {
  [key: string]: any;
} = AllBetsTypes;
